import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { ComponentListApi } from '@backend/api/stores/ComponentListStore'
import { apiFetch } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<ComponentListApi>('/api/stores/componentList', { fetch: apiFetch })

export const filterCategoryAtom = atom('')
export const filterStatusAtom = atom('')
export const filterKeywordAtom = atom('')

export const refreshAtom = atomWithQuery((get) => {
  const categoryId = get(filterCategoryAtom)
  const status = get(filterStatusAtom)
  const keyword = get(filterKeywordAtom)
  return {
    queryKey: ['ComponentListStore', categoryId, status, keyword],
    queryFn: async () => {
      const query: Record<string, string> = {}
      if (categoryId) query.categoryId = categoryId
      if (status) query.status = status
      if (keyword) query.keyword = keyword
      const res = await api.refresh.$get({ query })
      return await res.json()
    },
  }
})

export function loader(store: Store) {
  store.set(filterCategoryAtom, '')
  store.set(filterStatusAtom, '')
  store.set(filterKeywordAtom, '')
  store.get(refreshAtom)
  return null
}
